import {ServerError, ServerParseError} from '@apollo/client/errors';

export const isAuthenticationError = (error: unknown): boolean =>
  (ServerError.is(error) || ServerParseError.is(error)) &&
  (error.statusCode === 401 || error.statusCode === 403);
